import { useChargingModel } from 'modules/billing/hooks/useChargingModel';

import { Balance } from './components/Balance';
import { Buttons } from './components/Buttons';
import { Header } from './components/Header';
import { ProgressBar } from './components/ProgressBar';
import { useBalanceCardStyles } from './useBalanceCardStyles';

export interface BalanceCardProps {
  className?: string;
  onButtonClick?: () => void;
}

export const BalanceCard = ({ className, onButtonClick }: BalanceCardProps) => {
  const chargingModel = useChargingModel();

  const { classes, cx } = useBalanceCardStyles();

  return (
    <div className={cx(classes.root, className)}>
      <Header chargingModel={chargingModel} />
      <Balance chargingModel={chargingModel} />
      <ProgressBar chargingModel={chargingModel} />
      <Buttons chargingModel={chargingModel} onButtonClick={onButtonClick} />
    </div>
  );
};
